import React, { useEffect } from 'react';

import cx from 'classnames';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Features, isFeatureEnabled } from '../../../../featureToggles/features';
import { getPackagesInfo } from '../../../../slices/packagesInfo/index.thunk';
import { hasCurrentEnterpriseTrial, hasCurrentProTrial, hasPastProTrial, selectPackagesInfoLoading } from '../../../../slices/packagesInfo/selectors';
import { SxTooltip } from '../../../common/utils/wrapComponents';

interface Props {
  className?: string;
  onClick: () => void;
}

export const ProTrialButton = (props: Props): React.ReactElement | null => {
  const { className, onClick } = props;
  const dispatch = useDispatch();
  const hasPastTrial = useSelector(hasPastProTrial);
  const hasProTrialActive = useSelector(hasCurrentProTrial);
  const hasEnterpriseTrialActive = useSelector(hasCurrentEnterpriseTrial);
  const hasCurrentTrial = hasProTrialActive || hasEnterpriseTrialActive;
  const loading = useSelector(selectPackagesInfoLoading);

  useEffect(() => {
    dispatch(getPackagesInfo());
  }, [dispatch]);

  let tooltipText = '';

  if (hasPastTrial) {
    tooltipText = 'You\'ve already used your free trial! Update your plan to access Pro features.';
  }

  if (hasCurrentTrial) {
    tooltipText = 'You have a free trial in progress!';
  }

  const disabled = hasPastTrial || hasCurrentTrial || loading;

  if (!isFeatureEnabled(Features.TrialsOfTiers)) {
    return null;
  }
  return (
    <SxTooltip
      Component={<Button type='link' disabled={disabled} onClick={onClick} className={cx(className)}>Try Pro for free</Button>}
      tooltipText={tooltipText}
      hideTooltip={!tooltipText}
    />
  );
};
